export default [
    {
        path: '/monitoring',
        redirect: '/monitoring',
        name: 'monitoring',
        component: () => import('@/views/NestedRoute.vue'),
        children: [
            {
                path: '',
                name: 'monitoringIndex',
                component: () => import('@/views/monitoring/Index.vue'),
                meta: {
                    action: 'Lihat',
                    resource: 'monitoring',
                    pageTitle: 'Monitoring',
                    breadcrumb: [
                        {
                            text: 'Monitoring',
                            active: true,
                        },
                    ],
                },
            },
        ]
    }
]